import { Link } from 'react-router';

export function NotFound() {
  return (
    <div className="card text-center py-6 mt-2">
      <b className="font-head font-bold text-base block">That page isn't here</b>
      <p className="text-muted text-[13.5px] m-0 mb-3">It may belong to a module that isn't on, or the link is old.</p>
      <Link className="btn btn-primary" to="/">Back to today</Link>
    </div>
  );
}
